import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import reducer from "./course_reducer";
import { BASE_URL } from "../../Config/Config";

const Appcontext = createContext();
const API = `${BASE_URL}/coursemaster/`;

const Courseprovider = ({ children }) => {

  // 🍀 React Query function
  const fetchCourses = async () => {
    const response = await fetch(API, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    const data = await response.json();
    return data.data;
  };

  // 🎉 Fetch using useQuery
  const { data, isLoading, isError } = useQuery({
    queryKey: ["courses"],   // unique key for caching
    queryFn: fetchCourses,   // API function
    staleTime: 1000 * 60 * 5 // (optional) cache for 5 mins
  });

  return (
    <Appcontext.Provider value={{
      courses: data || [],
      isloading: isLoading,
      isError
    }}>
      {children}
    </Appcontext.Provider>
  );
};

// Custom Hook
export const Usecoursecontext = () => {
  return useContext(Appcontext);
};

export { Courseprovider };
